import { useEffect, useState } from "react";
import { useRecoilState } from "recoil";
import { userSimpleAtom } from "recoil/userSimpleAtom";
import { userApi } from "api/userApi";

export default function useFetchUserV3() {
  const [isFetching, setIsFetching] = useState(false);
  const [user, setUser] = useRecoilState(userSimpleAtom);

  useEffect(() => {
    // accessToken은 있지만 nickname이 없으면 user 정보 가져오기
    if (user?.accessToken && !user?.nickname && !isFetching) {
      setIsFetching(true);

      const fetchUser = async () => {
        try {
          const response = await userApi.getSimpleV3();

          if (response.code === 0 && response.result) {
            setUser((prev) => ({
              ...prev,
              ...response.result,
            }));
          }
        } catch (error) {
          console.error("Failed to fetch user info:", error);
        } finally {
          setIsFetching(false);
        }
      };

      fetchUser();
    }
  }, [user?.accessToken, user?.nickname, isFetching, setUser]);

  return { isFetching };
}
